/* Carrossel dos produtos relacionados (sections/related-products).
   O <product-recommendations> do Dawn injeta os cards depois de buscar as recomendações;
   este elemento inicia o Swiper (carregado no theme.liquid) assim que entra na página. */
if (!customElements.get('res-related-swiper')) {
  customElements.define(
    'res-related-swiper',
    class ResRelatedSwiper extends HTMLElement {
      connectedCallback() {
        if (this.swiper) return;
        this.filterSlides();
        if (typeof window.Swiper === 'undefined') return;

        const desktop = Number(this.dataset.desktop) || 4;
        const mobile = Number(this.dataset.mobile) || 2;

        this.swiper = new window.Swiper(this.querySelector('.res-rel__swiper'), {
          // no celular, uma fatia do próximo card indica que dá para arrastar
          slidesPerView: mobile + 0.2,
          spaceBetween: 12,
          watchOverflow: true,
          grabCursor: true,
          navigation: {
            prevEl: this.querySelector('[data-rel-prev]'),
            nextEl: this.querySelector('[data-rel-next]'),
          },
          pagination: {
            el: this.querySelector('[data-rel-pagination]'),
            clickable: true,
          },
          breakpoints: {
            750: { slidesPerView: Math.min(desktop, 3), spaceBetween: 16 },
            990: { slidesPerView: desktop, spaceBetween: 16 },
          },
        });
      }

      // tira os kits da família do produto atual (já estão no seletor) e limita à quantidade configurada
      filterSlides() {
        const exclude = (this.closest('product-recommendations')?.dataset.exclude || '').split(',').filter(Boolean);
        const max = Number(this.dataset.max) || Infinity;
        let shown = 0;
        this.querySelectorAll('.res-rel__slide').forEach((slide) => {
          if (exclude.includes(slide.dataset.productId) || shown >= max) slide.remove();
          else shown += 1;
        });
        if (shown === 0) this.closest('.shopify-section')?.classList.add('hidden');
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }
    }
  );
}
